module.exports = __webpack_public_path__ + "img/titleImg.2655c9c9.png";